
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import DescriptionOffers from "@/components/Jobs/Common/DescriptionOffers.vue";

@Component({
  components: {
    HeaderOffers: () => import("@/components/Jobs/Common/HeaderOffers.vue"),
    Compatibility: () => import("@/components/Compatibility.vue"),
    DescriptionOffers: () =>
      import("@/components/Jobs/Common/DescriptionOffers.vue")
  }
})
export default class OfferCard extends Vue {
  @Prop(Object) offer!: any;
  @Prop(Function) openModal!: any;
  @Prop(Function) show_detail!: any;
  @Prop(Boolean) withInfo!: boolean;
  @Prop(String) offerType!: string;
  @Prop(Boolean) withTag!: boolean;
  @Prop(Boolean) withFav!: boolean;
  @Prop(Boolean) withNetwork!: boolean;
  @Prop(Boolean) withNetwork2!: boolean;
  @Prop(Boolean) withDate!: boolean;
  @Prop(Boolean) withVacancies!: boolean;
  @Prop(Boolean) isPostulate!: Boolean;
  status = [
    "Postulación pendiente",
    "Postulación recibida",
    "Postulación rechazada",
    "Postulación leída"
  ];
  msgTooltipDefault = {
    title: "Medimos tu Compatibilidad",
    description:
      "Si completas tu perfil con tus habilidades, podemos medir cuan compatible sos con esta oferta."
  };

  getStatus(type: any) {
    return this.status[type];
  }
  async toggleOffer() {
    const _this: any = this;
    _this.offer.favorite = !_this.offer.favorite;
    await _this.$root._post(`useroffer`, {
      offerId: _this.offer.id,
      postulate: _this.offer.postulate ? 1 : 0,
      favorite: _this.offer.favorite ? 1 : 0
    });
    _this.$root.reloadUser();
    // (location as any).reload();
  }
}
